import '../scss/app.scss';


// Your JS Code goes here
// import Hero from '../components/hero/hero.js'
import Header from '../components/header/header.js'
let headerEl = document.querySelector(".header");
let header = new Header();
header.init(headerEl)


import Video from '../components/video/video.js'
import People from '../components/people/people.js'
let peopleContainers = document.querySelectorAll(".people");
peopleContainers.forEach((peopleEl) => {
	let peopleWrapper = new People();
	peopleWrapper.init(peopleEl);
});

import Logocard from '../components/logocard/logocard.js'
let logocardContainers = document.querySelectorAll(".logocard");
logocardContainers.forEach((logocardEl) => {
	let logocardWrapper = new Logocard();
	logocardWrapper.init(logocardEl);
});
import WorkFilter from '../components/work-filter/work-filter.js'
// import Clock from '../components/clock/clock.js'
import Accordion from '../components/accordion/accordion.js';
let accordionContainers = document.querySelectorAll(".accordion");
accordionContainers.forEach((accordionEl) => {
	let accordionWrapper = new Accordion();
	accordionWrapper.init(accordionEl);
});

// import Footer from '../components/footer/footer.js';
// import BackButton from '../components/button/backbutton.js';
// import ContactForm from '../components/contactform/contactform.js';
import Flipbook from '../components/flipbook/flipbook.js';
import FlipdotDisplay from '../components/flipdotdisplay/flipdotdisplay.js';
import Gallery from "../components/gallery/gallery.js";

let galleries = document.querySelectorAll(".gallery");
galleries.forEach((galleryEl) => {
	let gallery = new Gallery();
	gallery.init(galleryEl);
});

import ImageSticker from "../components/image-sticker/image-sticker.js";

let imageStickers = document.querySelectorAll(".image-sticker");
imageStickers.forEach((imageStickerEl) => {
  let imageSticker = new ImageSticker();
  imageSticker.init(imageStickerEl);
});



import Textexpand from "../components/textexpand/textexpand.js";

let textexpands = document.querySelectorAll(".textexpand");
textexpands.forEach((textexpandEl) => {
  let textexpand = new Textexpand();
  textexpand.init(textexpandEl);
});


import ContactAnimations from "../components/contactdetails/contactdetails.js";

const contactRoots = document.querySelectorAll('.contact-details');
contactRoots.forEach((contactRoot) => {
	const contactAnimations = new ContactAnimations();
	contactAnimations.init(contactRoot);
});



// import FounderVideo from '../components/foundervideo/foundervideo.js'
// import Features from '../components/features/features.js'
// import Mobilemenu from '../components/mobilemenu/mobilemenu.js'
// import Storytelling from '../components/storytelling/storytelling.js'
// import ScrollFadeIn from '../components/scrollfadein/scrollfadein.js'
// import WebGL from '../components/webgl/webgl.js'
// import barba from '@barba/core';
// import { gsap } from "gsap";

// let footerEl = document.querySelector(".footer");
// let footer = new Footer();
// // console.log(footer)
// footer.init(footerEl)

// let accordions = document.querySelectorAll(".accordion");
// accordions.forEach(accordionEl => {
//   let accordion = new Accordion();
//   accordion.init(accordionEl)
// })

let flipbookEl = document.querySelector(".flipbook");
if(flipbookEl) {
	let flipbook = new Flipbook();
	flipbook.init(flipbookEl)
}

let flipdotdisplayEl = document.querySelector(".flipdotdisplay");
if(flipdotdisplayEl) {
	let flipdotdisplay = new FlipdotDisplay();
	flipdotdisplay.init(flipdotdisplayEl)
}


// let clocks = document.querySelectorAll(".clock");
// clocks.forEach(clockEl => {
//   let clock = new Clock();
//   clock.init(clockEl)
// })

let videos = document.querySelectorAll(".simple-video");
videos.forEach(videoEl => {
  let video = new Video();
  video.init(videoEl)
})

// let backbuttons = document.querySelectorAll(".backbutton");
// backbuttons.forEach(backbuttonEl => {
//   let backbutton = new BackButton();
//   backbutton.init(backbuttonEl)
// })

window.setTimeout(() => {
	document.querySelectorAll('.video-autoplay-wrapper').forEach(videoWrapper => {
		const video = videoWrapper.querySelector('.video-autoplay')
		const btn = videoWrapper.querySelector('.toggle-animations')

		if(btn.classList.contains("is-paused")) {
			video.muted = true;
			video.play().catch(error => {
				console.error('Autoplay was prevented:', error);
			});
		}
	});
}, 4000);

document.querySelectorAll('.video-autoplay-wrapper').forEach(videoWrapper => {
	const video = videoWrapper.querySelector('.video-autoplay')
	const btn = videoWrapper.querySelector('.toggle-animations')
	btn.addEventListener('click', () => {
		if (video.paused) {
			video.play();
			btn.classList.remove('is-paused');
		} else {
			video.pause();
			btn.classList.add('is-paused');
		}
	});
});

if(document.querySelector(".work-has-filter")) {
	let workFilter = new WorkFilter();
	let workFilterEl = document.querySelector(".work-has-filter");
	workFilter.init(workFilterEl)
}

// const contactFormEl = document.querySelector('.contactform');
// if(contactFormEl) {
// 	const contactForm = new ContactForm();
// 	contactForm.init(contactFormEl);
// }


import Eventlist from '../components/eventlist/eventlist.js'
let Eventlists = document.querySelectorAll(".eventlist");
Eventlists.forEach((eventlistEl) => {
	let eventlist = new Eventlist();
	eventlist.init(eventlistEl);
});





//COOKIE CONSENT COOKIE CONSENT COOKIE CONSENT COOKIE CONSENT
// we can either import Klaro without styles...
import * as Klaro from "klaro/dist/klaro-no-css";
// and the manually load the styles (e.g. to bundle them manually)
import "klaro/dist/klaro.css";
// or we can import Klaro with styles:
// import * as Klaro from "klaro";

// we define a minimal configuration
const config = {
    translations: {
        en: {
            gtm: {
                title: "Google Tag Manager / Google Analytics",
                description: 'Analytics cookies help us to understand how our visitors use our website. (Provider: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland, https://policies.google.com/privacy)',
            },
			consentNotice: {
				description: 'Analytics help us understand how our visitors use our website to improve your user experience. Find out more about the use of Google Analytics / Google Tag Manager in our <a href="./datenschutz" target="_blank" rel="noopener noreferrer">privacy policy</a>.',
				learnMore: 'Change settings',
			},
            purposes: {
                analytics: "Analytics",
            }
        },
        de: {
            gtm: {
                title: "Google Tag Manager / Google Analytics",
                description: 'Statistik Cookies helfen uns zu verstehen, wie unsere Besucher unsere Website nutzen. (Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland, https://policies.google.com/privacy)',
            },
			consentNotice: {
				description: 'Statistiken helfen uns zu verstehen, wie unsere Besucher unsere Website nutzen um dein Nutzererlebnis zu verbessern. Mehr über die Verwendung von Google Analytics / Google Tag Manager in unserer <a href="./datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a>.',
				learnMore: 'Einstellungen anpassen',
			},
            purposes: {
				analytics: "Analytics",
            },
			// consentModal: {
			// 	description: 'Wir verwenden Cookies, um unsere Website zu verbessern. Um mehr zu erfahren, <a href="./datenschutz" target="_blank" rel="noopener noreferrer">lies bitte unsere Datenschutzerklärung</a>.',
			// },
        }
    },
	htmlTexts: true,
	acceptAll: true,
	privacyPolicy: './datenschutz', // nur für den Button-Link unten im Dialog
    services: [
        {
            name: 'gtm', // muss zu translations.gtm passen
            title: 'Google Tag Manager & Google Analytics',
            purposes: ['analytics'],
            cookies: ['_ga', '_gid', '_gat', 'dc_gtm_*'],
            required: false,
            optOut: false,
            // onlyOnce: true,
            onAccept: () => {
                const script = document.createElement('script');
                script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KV9RPPW'; // <- GTM-ID
                script.async = true;
                document.head.appendChild(script);
				// console.log('Analytics loaded');
            },
        },
    ]
};

window.klaro = Klaro;
window.klaroConfig = config;
Klaro.setup(config);